<template>
    <form class="auth-form" action="POST" @submit.prevent="handleRegisterForm()">
        <h1 class="auth-form__title">Zaloguj się</h1>

        <div class="auth-form__fields">
            <form-input
                label="Adres e-mail:"
                v-model="email"
                :modelValue="email"
                type="email"
                name="email"
                placeholder="adres email..."
                :error-messages="errorMessage"
            ></form-input>

            <form-input
                label="Hasło:"
                v-model="password"
                :modelValue="password"
                type="password"
                name="password"
                placeholder="Hasło..."
                :error-messages="errorMessage"
            ></form-input>
        </div>

        <div class="auth-form__footer">
            <label class="auth-form__remember" for="remember">
                <input
                    id="remember"
                    v-model="remember"
                    class="auth-form__checkbox"
                    type="checkbox"
                    name="remember"
                    value="true"
                >
                Zapamiętaj mnie
            </label>

            <div class="auth-form__actions">
                <vue-simple-spinner v-if="processing"></vue-simple-spinner>
                <button v-else type="submit" class="auth-form__submit">Zaloguj się</button>

                <div class="auth-form__links">
                    <a href="/password/reset" class="auth-form__link">Nie pamiętasz hasła?</a>
                    <a href="/rejestracja" class="auth-form__link auth-form__link--bold">Załóż konto</a>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import FormInput from "./formInput";
import Spinner from 'vue-simple-spinner';

export default {
    components: {
        FormInput,
        Spinner,
    },
    data() {
        return {
            email: '',
            password: '',
            remember: '',
            processing: '',
            errorMessage: null,
        }
    },

    methods: {
        handleRegisterForm() {
            axios.post('/api/login', {
                email: this.email,
                password: this.password,
                remember: this.remember
            })
                .then(response => {
                    this.processing = true;
                })
                .then(response => {
                    this.processing = false;
                    window.location.href = '/';
                })
                .catch(error => {
                    this.errorMessage = error.response.data.errors;
                })
                .then(error => {
                    window.scrollTo(document.querySelector('.error').offsetTop, 0);
                });
        }
    }

}

</script>
